import { createAsyncThunk } from "@reduxjs/toolkit";
import { deposit } from "api/deposit";
import { MemberOrderPayload } from "api/deposit/type";
import {
  DepositSubmissionFormType,
  OnlineDepositSubmissionType,
  WithdrawalSubMissionType,
} from "types/deposit";

export const getDepositForm = createAsyncThunk(
  "deposit/getDepositForm",
  async (username: string, { rejectWithValue }) => {
    try {
      const dataDepositForm = await deposit.getDepositForm(username);
      return dataDepositForm;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const depositSubmission = createAsyncThunk(
  "deposit/depositSubmission",
  async (formData: DepositSubmissionFormType, thunkApi) => {
    try {
      const response = await deposit.depositSubmission(
        formData.username,
        formData
      );

      return response;
    } catch (error) {
      return thunkApi.rejectWithValue(error);
    }
  }
);

export const onlineDepositSubmission = createAsyncThunk(
  "deposit/depositSubmission",
  async (formData: OnlineDepositSubmissionType, thunkApi) => {
    try {
      const response = await deposit.onlineDepositSubmoission(
        formData.username,
        formData
      );

      return response;
    } catch (error) {
      return thunkApi.rejectWithValue(error);
    }
  }
);

export const getMemberOrders = createAsyncThunk(
  "deposit/getMemberOrders",
  async (data: MemberOrderPayload, { rejectWithValue }) => {
    try {
      const dataMemberOrder = await deposit.memberOrder(data.username, data);
      return dataMemberOrder;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getWithdrawalForm = createAsyncThunk(
  "deposit/getWithdrawalForm",
  async (username: string, { rejectWithValue }) => {
    try {
      const dataWithdrawal = await deposit.getWithdrawalForm(username);
      return dataWithdrawal;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const withdrawalSubmission = createAsyncThunk(
  "deposit/withdrawalSubmission",
  async (formData: WithdrawalSubMissionType, { rejectWithValue }) => {
    try {
      const response = await deposit.withdrawalSubmission(
        formData.username,
        formData
      );

      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
